var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0,
    width: 25,
    height: 13,
    rx: 6.5,
    fill: "#76b72b"
  }))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "S2",
    transform: "translate(7, 10.0202)",
    style: {
      fontWeight: "bold",
      fontSize: 10,
      fontFamily: "HelveticaNeue-Bold, 'Helvetica Neue'",
      fill: "#fff"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 0.24,-2.37 h 1.52 q 0,0.67 0.48,1.02 0.41,0.3 1.1,0.3 0.54,0 0.9,-0.17 0.49,-0.23 0.49,-0.72 0,-0.61 -1.1,-0.92 -1.9,-0.54 -2.05,-0.62 -1.1,-0.53 -1.1,-1.67 0,-1.03 0.85,-1.63 0.76,-0.53 1.82,-0.53 1.23,0 1.99,0.53 0.87,0.61 0.87,1.77 H 4.49 Q 4.43,-6.09 3.08,-6.09 2.65,-6.09 2.35,-5.91 2,-5.69 2,-5.28 q 0,0.39 0.39,0.57 0.3,0.14 1.74,0.51 0.84,0.21 1.25,0.48 0.87,0.56 0.87,1.6 0,1.02 -0.76,1.64 -0.8,0.65 -2.21,0.65 -1.29,0 -2.12,-0.61 -0.93,-0.69 -0.92,-1.93 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 8.2199826,-4.31 h -1.36 q -0.04,-1.24 0.63,-2.03 0.68,-0.8 1.91,-0.8 1.0000004,0 1.6800004,0.58 0.72,0.62 0.72,1.61 0,0.93 -0.62,1.59 -0.31,0.33 -1.3600004,1.01 -0.92,0.61 -1.29,1.13 H 11.839983 V 0 H 6.6999826 q 0.01,-1.09 0.65,-1.87 0.41,-0.48 1.56,-1.26 0.82,-0.56 0.97,-0.69 0.5000004,-0.46 0.5000004,-1.02 0,-0.49 -0.3,-0.78 -0.2900004,-0.3 -0.7500004,-0.3 -0.58,0 -0.87,0.53 -0.24,0.43 -0.24,1.08 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/s2.b314f1a5b697da8acc2755bcc5cf34e3.svg";
export { ForwardRef as ReactComponent };